// Promo-modals

( function($, waTheme) {

    var $licModal = $("#licModal");
    if ($licModal.length) {
        $licModal.modal("show");
    } else if (window.waTheme.license.is_standart === "" && window.waTheme.license.is_premium === "" && window.waTheme.user.is_admin === "1") {
        var $html = `<div class="modal fade" id="licModal" tabindex="-1" aria-labelledby="licModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="modal-title fs-5" id="licModalLabel">${window.waTheme.locale.lic_none}</div>
                                </div>
                                <div class="modal-body">
                                    ${window.waTheme.locale.lic_none_text}
                                </div>
                                <div class="modal-footer">
                                    <a href="https://www.webasyst.ru/store/theme/seller/" target="_blank" class="btn btn-theme">
                                        ${window.waTheme.locale.lic_none_button}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>`;
        $("body").append($html);
        $("#licModal").modal("show");
    }

})(jQuery, window.waTheme);